import { isPrequalE2eExperimentsEnabled } from 'app/e2e/mode'
import { usePostHog } from 'posthog-js/react'
import { useEffect, useState } from 'react'

/**
 * PostHog: experiment flag for the prequal financial-info step
 * (non-QC job start on employment, financial-info step, progress mapping).
 *
 * Multivariate PostHog experiment flag — "test" variant means the feature is on.
 */
export const POSTHOG_FEATURE_PREQUAL_FINANCIAL_INFO_ENABLED = 'prequal-page-financial-info'

/**
 * True only when the "test" variant of the prequal financial-info experiment is active.
 *
 * PostHog handles outages internally (returns `undefined`), which won't match `"test"` —
 * effectively defaulting to the disabled path.
 */
export function useIsPrequalFinancialInfoEnabled(): boolean {
    const e2eEnabled = isPrequalE2eExperimentsEnabled()
    const posthog = usePostHog()
    const [enabled, setEnabled] = useState<boolean>(() => e2eEnabled || posthog?.getFeatureFlag(POSTHOG_FEATURE_PREQUAL_FINANCIAL_INFO_ENABLED) === 'test')

    useEffect(() => {
        if (e2eEnabled || !posthog) {
            return undefined
        }

        const evaluate = () => setEnabled(posthog.getFeatureFlag(POSTHOG_FEATURE_PREQUAL_FINANCIAL_INFO_ENABLED) === 'test')

        evaluate()
        const unsubscribe = posthog.onFeatureFlags(evaluate)

        return () => {
            if (unsubscribe) {
                unsubscribe()
            }
        }
    }, [e2eEnabled, posthog])

    return e2eEnabled || enabled
}
